<template>
  <div>
    <div class="menu">
      <div class="logo-box">
        <img src="../assets/logo.png" class="logo" />
        <p>PT DANISWARA TEKNOLOGI INDONESIA</p>
      </div>
      <div class="menu-box">
        <div class="list">
          <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">
            halaman Depan
          </div>
          <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
            tentang kami
          </div>
          <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
            Layanan bisnis
          </div>
          <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">
            Produk kami
          </div>
          <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
            LimitBee
          </div>
          <div :class="step == 6 ? 'select' : ''" @click="selectMenu(6)">
            Hubungi kami
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: "Menu",
    props: {
      step: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        index: 0,
      };
    },
    methods: {
      selectMenu(value) {
        this.index = value;
        if (value == this.step) {
          return;
        }
        switch (value) {
          case 1:
            this.$router.push({ path: "/" });
            break;
          case 2:
            this.$router.push({ path: "about" });
            break;
          case 3:
            this.$router.push({ path: "services" });
            break;
          case 4:
            this.$router.push({ path: "products" });
            break;
          case 5:
            this.$router.push({ path: "limitbee" });
            break;
          case 6:
            this.$router.push({ path: "contact" });
            break;
          default:
            this.$router.push({ path: "/" });
            break;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .menu {
    padding: 0 360px;
    display: flex;
    justify-content: space-between;

    .logo-box {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .logo {
        width: 48px;
        height: 48px;
        margin-right: 14px;
      }

      p {
        font-family: DINCondensed, DINCondensed;
        font-weight: bold;
        font-size: 21px;
        color: #25274D;
      }
    }
  }

  .menu-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;

    cursor: pointer;

    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .select {
        color: #F42D41;
      }

      div {
        padding: 0 8px;
        font-family: Arial, Arial;
        font-weight: normal;
        font-size: 16px;
        color: #333333;
        white-space: nowrap;
      }
    }

    .btn {
      width: 112px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #ffd808;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 16px;
      border-radius: 4px 4px 4px 4px;
      color: #333;
      margin-right: 40px;
    }
  }
</style>